// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1ekGJm2O5DwWhtXr_CA9LJ"};